import React from "react"
import { useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import SearchORGResults from "./SearchORGResults"

function OrganizationData(props) {
   const [selectedItems, setSelectedItems] = useState("")
   
   const handleSelectedItems = (organizationName) => {
      // organizationName is a string passed from SearchORGResults
      setSelectedItems(organizationName)
   }
   
   const handleSave = () => {
      if (selectedItems && selectedItems.trim() !== "") {
         // Pass the organization name string to parent
         props.getOrganization(selectedItems)
         props.handleCloseOrganization()
      } else {
         alert("Please select an organization")
      }
   }
   
   return (
      <>
         <Modal
            aria-labelledby="contained-modal-title-vcenter"
            size="md"
            centered
            dialogClassName="my-modal"
            style={{ overflowY: "hidden" }}
            backdrop="static"
            keyboard={false}
            show={props.show}
            onHide={props.handleCloseOrganization}
         >
            <Modal.Header closeButton>
               <Modal.Title id="contained-modal-title-vcenter">
                  Search Organizations
               </Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <Form>
                  <Row style={{ height: "410px" }}>
                     <Col md={8} sm={8}>
                        <div className="loginTextHeader" style={{ textAlign: "center" }}>
                           Search Results
                        </div>
                        <SearchORGResults
                           results={props.results || []}
                           handler={handleSelectedItems}
                        />
                     </Col>
                  </Row>
                  <br />
               </Form>
            </Modal.Body>
            <Modal.Footer>
               <Button variant="primary" onClick={handleSave}>
                  Submit
               </Button>
               <Button variant="secondary" onClick={props.handleCloseOrganization}>
                  Close
               </Button>
            </Modal.Footer>
         </Modal>
      </>
   )
}

export default OrganizationData